import Box from "@mui/material/Box";

import { Card, CardContent } from "@mui/material";
import Stack from "@mui/material/Stack";
import "ag-grid-enterprise";
import {
  ColDef, IServerSideGetRowsParams
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import dayjs from "dayjs";
import FileSaver from "file-saver";
import { useContext, useEffect, useRef, useState } from "react";
import { transformationActions } from "../../service/transformation.action";
import "./../genericModels.css";

import { useTranslation } from "react-i18next";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import CustomLoader from "../../../../util/component/CustomLoader";
import EmptyState from "../../../../util/component/EmptyState";
import { setSnackbar } from "../../../../util/state/globalAction";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { ContextOperation } from "../../context/OperationContext";
import { FileTextWithIcon } from "../common/FileTextWithIcon";
import { Parser } from "../../utils";
import AgGridOperationTable from "../common/AgGridOperationTable";

export const TransportPerRouteTable = (props:any) => {
  const { tenant } = useContext(ContextOperation);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const { t } = useTranslation(["operation"]);
  const gridRef = useRef<AgGridReact>(null);
  const [refresh, setRefreshPage] = useState<boolean>(false);
 
  const [rowLength, setRowLength] = useState<number>(0);
  const [gridApi, setGridApi] = useState<any>(null);
  const [isremoveChip, setIsRemoveChip] = useState<boolean>(false);
  const [showChip, setShowChip] = useState<boolean>(false);
  const [filersChips, setFiltersChips] = useState<any>({});
  const [loading, setIsLoading] = useState<boolean>(false);
  let supplierId = props.getIdSupplier;
const [refreshTableOne,  setRefreshTableOne] = useState<boolean>(false)
// const [pageSize, setPageSize] = useState<number>(10);
let pageSize = 10;
const columnDefs:ColDef[] = [
  {
    field: "startProvinceDescr",
    headerName: t(
      "transportSupplierPriceList.priceListRouteTable.startProvince"
    ),
    flex: 1.1,
    cellRenderer(params: any) {
      return (
        <Box
        component={'span'}
        >
          <Box  component={'span'} textTransform="capitalize">
            {params.data.startProvinceDescr}
          </Box>
          &nbsp;
          <Box  component={'span'}  textTransform="uppercase">

         ({params.data.startProvinceCode})
          </Box>
        </Box>
      );
    },
  },
  {
    field: "endProvinceDescr",
    headerName: t(
      "transportSupplierPriceList.priceListRouteTable.endProvince"
    ),
    flex: 1.1,
    cellRenderer(params: any) {
      return (
        <Box
        component={'span'}
        >
          <Box  component={'span'} textTransform="capitalize">
            {params.data.endProvinceDescr}
          </Box>
          &nbsp;
          <Box  component={'span'}  textTransform="uppercase">

         ({params.data.endProvinceCode})
          </Box>
        </Box>
      );
    },
  },
  {
    field: "loadIndex",
    headerName: t("transportSupplierPriceList.priceListRouteTable.loadIndex"),
    flex: 0.8,
    cellRenderer(params: any) {
      return (
       
          <Box component={'span'}>{params.data.loadIndex}</Box>
        
      );
    },
  },

  {
    field: "excelFile",
    headerName: t(
      "transportSupplierPriceList.priceListRouteTable.priceListFile"
    ),
    flex: 1,
    cellRenderer(params: any) {
      return (
      //   <Stack
      //   height="inherit"
      //   alignItems="center"
      //   alignContent="center"
      //   direction="row"
      // >
      //   <Tooltip title={params.data.excelFile}>
      //     <Grid
      //       container
      //       spacing={0.5}
      //       columns={12}
      //       color="black"
      //       alignItems="center"
      //       onClick={() => downloadTemplateById(params.data.idFile)}
      //     >
            
      //       <Grid
      //         item
      //         xs={8}
             
      //       >
      //         <Typography
      //           maxWidth={200}
      //           noWrap
      //           sx={{
      //             overflow: "hidden",
      //             fontSize: "10px",
      //             textTransformation: "none",
      //             textOverflow: "ellipse",
      //             textDecoration: "underline",
      //           }}
      //           color="inherit"
      //         >
      //           {params.data.excelFile}
      //         </Typography>
      //       </Grid>
      //       <Grid sx={{display:'flex', alignItems:"flex-end"}}  item xs={'auto'}>
      //         <Box>
      //           <FileDownloadIcon
      //             sx={{ fontSize: "17px"}}
      //           />
      //         </Box>
      //       </Grid>
      //     </Grid>
      //   </Tooltip>
      // </Stack>
      <FileTextWithIcon 
      onDownloadFile={() => {downloadTemplateById(tenant, params.data.idFile)}}
      fileTextDownload={params.data.excelFile}
      fileWidth={true}>

   </FileTextWithIcon>
      );
    },
  },
  {
    field: "startValidityDatetime",
    headerName: t(
      "transportSupplierPriceList.priceListRouteTable.startValidity"
    ),
    flex: 1,
    cellRenderer(params: any) {
      return (
       
          <Box  component={'span'}>
            {dayjs(`${params.data.startValidityDatetime}`).format(
              "DD/MM/YYYY"
            )}
          </Box>
        
      );
    },
  },
  {
    field: "endValidityDatetime",
    headerName: t(
      "transportSupplierPriceList.priceListRouteTable.endValidity"
    ),
    flex: 1,
    cellRenderer(params: any) {
      return (
       
          <Box  component="span" >
            {dayjs(`${params.data.endValidityDatetime}`).format("DD/MM/YYYY")}
          </Box>
       
      );
    },
  },
  {
    field: "price",
    headerName: t("transportSupplierPriceList.priceListRouteTable.price"),
    flex: 1,
    cellRenderer(params: any) {
      return (
        <Box component={'span'} sx={{ fontWeight: "700" }}>
              {params.data.currencyCode}
              {Parser.price(params.data.price)}
            </Box>
      );
    },
  },
];
const downloadTemplateById = (tenant: string, id: number) => {
  setIsLoading(true);
  transformationActions()
    .downloadTemplateById(tenant, id)
    .then((response: any) => {
      setIsLoading(false);
      const filename =
        response?.headers["content-disposition"].split("filename=")[1];
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, filename);
    });
};

const MyCustomNoRowsOverlay = () => (
  <EmptyState title=  {t("carMaintenance.noVehicleSelected")}
     content = {t("carMaintenance.enterPlateOrVin")}/>

);

const getDistancepriceQueryParams = (dataSearchForm:any) => {
 
 
  let provinceStartId = !!dataSearchForm?.provinceStart?.id ? dataSearchForm?.provinceStart?.id :null;
  let provinceEndId = !!dataSearchForm?.provinceEnd?.id?dataSearchForm?.provinceEnd?.id:null;
  let dateTime =  (!!dataSearchForm?.dateTime && dayjs(dataSearchForm?.dateTime).isValid() )? dayjs
  (dataSearchForm?.dateTime )
  .format("YYYY-MM-DD"): null;
  return {
    getRows: async (params: IServerSideGetRowsParams) => {
      setIsLoading(true);

      const startRow = params.request.startRow ? params.request.startRow : 0;
      const endRow = params.request.endRow;
      let pageSize = 10;
      if (
        endRow !== null &&
        endRow !== undefined &&
        startRow !== null &&
        startRow !== undefined
      ) {
        pageSize = endRow - startRow;
      }
      const pageNumber = startRow / pageSize;
      
      transformationActions().getDistanceRouterPerPriceQueryParams(
          props.getTenant,
          pageNumber,
          pageSize,
          props.getIdSupplier,
          provinceStartId, 
          provinceEndId,
          dateTime
        ).then(
          (response: any) => {
            params.successCallback(
              manageData(response),
              response.data.totalElements
            );
            setRowLength(response.data.totalElements);
            
            setIsLoading(false);
          }
        ).catch((error) => {
          if (error.response) {
            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                  snackbar: {
                      message:(error.response.data.error),
                      type: snackbarTypes.error,
                      show: true,
                      autoClose: true,
                  }
              }
            });
            setIsLoading(false);
          } else if (error.request) {
            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                  snackbar: {
                      message:(t("networkErrorMessage")),
                      type: snackbarTypes.error,
                      show: true,
                      autoClose: true,
                  }
              }
            });
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
          setIsLoading(false);
        });
    },
  };
};
function manageData(response: any) {
  let rows: any[] = [];
  response.data.content.forEach((element: any) => {
    let row = {
      id: element.id,
      startProvinceDescr: element.startProvinceDescr,
      endProvinceDescr: element.endProvinceDescr,
      loadIndex: element.loadIndex,
      routeKmSystem: element.routeKmSystem,
      routeKmSupplier: element.routeKmSupplier,
      excelFile: element.excelFile,
      startValidityDatetime: element.startValidityDate,
      endValidityDatetime: element.endValidityDate,
      price: element.price,
      startProvinceCode: element.startProvinceCode,
      endProvinceCode: element.endProvinceCode,
      currencyCode: element.currencyCode,
      idFile: element.idFile,
    };
    rows.push(row);
  });
  return rows;
}
const onGridReady = (params: any) => {
  setGridApi(params.api);
};


useEffect(() => {
  
  if (gridApi) {
    gridApi.setServerSideDatasource(
      getDistancepriceQueryParams(!!props.dataSearchForm ? props.dataSearchForm : null)
    );
  }
}, [gridApi, props.refreshPage, props.getIdSupplier]);
  

  return (
    <>
    <Box pl={2} pr={2}>
      <Box>
        { !props.hasSupplierId &&
            <Box >
              <Card>
                <CardContent >
                  
                <Stack  justifyContent = "center" height={500}>
                 
                <EmptyState title=  {t("transportSupplierPriceList.noSupplierMessage")}
                content = {t("transportSupplierPriceList.noSupplierContent")}/>
              
</Stack>
              </CardContent>
                </Card>
            </Box>
}

{props.hasSupplierId &&

  <Box >
    <AgGridOperationTable
      columnDefs={columnDefs}
      onGridReady={onGridReady}
      cacheBlockSize={pageSize}
      serverSideInfiniteScroll={true}
      rowModelType={"serverSide"}
      totalElements={rowLength} 

        
      />

  </Box>
  }

{loading && <CustomLoader loading={loading}/>}
         
      </Box>
      
    </Box>
  </>
  )
}
